import ComicButtons from '@/shared/Activities/ComicActivity/ComicButtons';
import CraftButtons from '@/shared/Activities/CraftActivity/CraftButtons';
import ShortStoryButtons from '@/shared/Activities/ShortStoryActivity/ShortStoryButtons';
import SongButtons from '@/shared/Activities/SongActivity/SongButtons';
import WorksheetButtons from '@/shared/Activities/WorksheetActivity/WorksheetButtons';
import RealTimeButtons from '@/shared/Activities/RealTimeActivity/Launchers/RealTimeActivity/RealTimeButtons';
import GuideExtraButton from './GuideExtraButton';
import useActivityVisibility from '@/v2/domains/Activities/hooks/useActivityVisibility.hook';
import { activityVisibility } from '@/v2/domains/Activities/constants/visibility';

export default function ActivityButtons({ activity }) {
  const visibility = useActivityVisibility({ activity });

  if (!activity?.type || visibility != activityVisibility.visible) {
    return null;
  }

  const Buttons = {
    song: SongButtons,
    comic: ComicButtons,
    shortStory: ShortStoryButtons,
    craft: CraftButtons,
    worksheet: WorksheetButtons,
    pictureDictionary: WorksheetButtons,
    realTime: RealTimeButtons,
    storyWithQuestions: ShortStoryButtons,
  }[activity.type];

  return (
    <>
      <GuideExtraButton activity={activity} />
      {Buttons && <Buttons activity={activity} />}
    </>
  );
}
